"use strict";
import {
  applyColorAndSizeStyleToNode,
  applyAlignmentStyleToDiv,
  applyAlignmentStyleToText,
} from "../utils/rendering/Utils-Html-Style.mjs";
import {
  renderIntoNode,
  uuid,
} from "../utils/rendering/Utils-Html-Rendering.mjs";
import { destroyObjectAttributes } from "../utils/memory/Utils-Memory";
import { renderMarkdownIntoNode } from "../utils/rendering/Utils-Markdown";
import { styleSettings } from "../../../../src/config/settings-features.mjs";
import { Question } from "../Question.mjs";
import {
  convertObjectIntoLatex,
  renderLatexIntoNode,
} from "../utils/rendering/Utils-Latex-Rendering.js";
import { flatten } from "../utils/numeric/Utils-Numeric.mjs";
export class ElementEleda {
  uuid;
  value; //Raw value for each Element (the main caracteristic of ElementEleda). Coordinates for point...
  properties;
  complexity;
  htmlNode;
  color;
  alignment;
  renderNode;
  /**
   * @constructor
   */
  //TO DO : use declaration of properties or and with # prefix to strenght private properties in objects (must be available in next ECMA version)
  //Usage : https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Classes

  constructor(value = null) {
    //  appendDEBUG("Element constructor");
    Activity.instances.push(this);
    this.uuid = uuid();
    this.value = value;
    this.properties = new Map();
    this.complexity = 0;
    this.eledaAttributes = {};
    this.style = {
      color: styleSettings.color.dark,
      size: "medium",
      // alignment: "left",
    };
  }
  destroy() {
    destroyObjectAttributes(this);
  }

  /** function to test equality btw 2 ElementEleda. If the following function is called
   * it means child doesn't implement it.
   */
  isEqualTo() {
    return false;
  }

  getStyle() {
    return this.style;
  }

  setStyle(jsonStyle) {
    this.style = { ...this.style, ...jsonStyle };
  }

  getEledaAttributes() {
    return this.eledaAttributes;
  }

  setEledaAttributes(json) {
    this.eledaAttributes = { ...this.eledaAttributes, ...json };
  }

  getValue() {
    return this.value;
  }

  toString() {
    try {
      return JSON.stringify(this);
    } catch (err) {
      return "Defined, but not able to display in text.";
    }
  }

  valueOf() {
    return this.toString();
  }

  computeComplexity() {}

  render(/*node*/) {}
}

/**
 * Element RichText (Paragraph)
 */
export class Element_RichText extends ElementEleda {
  /**
   * Create a Element_RichText (Named Paragraph).
   * @constructor
   */

  constructor(value = null) {
    super(value);
    //appendDEBUG('Element_Numeric constructor : value =' + value);
    if (this.value) {
      //flat all elements in case paragraph contains other array which doesn't have all numeric elts
      this.value = flatten(this.value);

      /*
      function flatten(items) {
        const flat = [];

        items.forEach((item) => {
          if (Array.isArray(item)) {
            flat.push(...flatten(item));
          } else {
            flat.push(item);
          }
        });

        return flat;
      }
      */
    }
  }

  /**
   * Set the value.
   * @param {number} numeric value
   */
  setValue(value) {
    this.value = Array.from(value);
    //appendDEBUG('Element_Numeric setValue : value =' + this.value);
  }

  render(node) {
    this.htmlNode = document.createElement("div");
    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style);

    for (let i in this.value) {
      let spanNode = document.createElement("span");
      //Uncomment this line if we want to apply paragraph styles on each object (it blocks styles on items in this case)
      //setStyleToObject(this.value[i], this.style);
      renderIntoNode(this.value[i], spanNode);
      this.htmlNode.appendChild(spanNode);
    }
    node.appendChild(this.htmlNode);
  }
}

export class Element_GridColumn extends ElementEleda {
  /**
   * Create a Element_RichText.
   * @constructor
   */

  constructor(value = null) {
    super(value);
  }

  /**
   * Set the value.
   * @param {number} numeric value
   */
  setValue(value) {
    this.value = Array.from(value);
  }

  render(node) {
    this.htmlNode = document.createElement("div");
    this.htmlNode.classList.add(
      "columns",
      "is-vcentered",
      "is-mobile",
      "is-multiline"
    );
    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style);
    for (let i in this.value) {
      let columnNode = document.createElement("div");
      columnNode.classList.add("column");
      //Alignment : has-text-* has no effect because is-narrow fit the cell to content
      //Color : this style gives color to text into in columns
      applyColorAndSizeStyleToNode(columnNode, this.value[i].style);
      applyAlignmentStyleToDiv(columnNode, this.value[i].style);
      renderIntoNode(this.value[i], columnNode);
      this.htmlNode.appendChild(columnNode);
    }
    node.appendChild(this.htmlNode);
  }
}

export class Element_SpecialCharacter extends ElementEleda {
  /**
   * Create a Element_SpecialCharacter.
   * @constructor
   */
  constructor(value = null) {
    super(value);
  }

  render(node) {
    this.htmlNode = document.createElement(this.value);
    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style);
    node.appendChild(this.htmlNode);
  }
}

export class Element_Markdown extends ElementEleda {
  /**
   * Create a Element_Markdown.
   * @constructor
   */
  constructor(value = null) {
    super(value);
  }
  /**
   * Returns markdown string
   * @returns String
   */
  toString() {
    console.log("markdown toString:", "\\(" + this.value + "\\)");
    return this.value;
  }

  render(node) {
    this.htmlNode = document.createElement("span");
    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style);
    renderMarkdownIntoNode(this.value, this.htmlNode);
    node.appendChild(this.htmlNode);
  }
}

export class Element_LaTeX extends ElementEleda {
  /**
   * Create a Element_LaTeX.
   * @constructor
   */
  constructor(value = null) {
    super(convertObjectIntoLatex(value));
  }

  equal(obj2) {
    return this.toString() == obj2.toString();
  }
  /**
   * Returns string parsable by MathJax (called by JSXGraph transparently when a text in figure is a latex)
   * @returns String
   */
  toString() {
    console.log("latex toString:", "\\(" + this.value + "\\)");
    return "\\(" + this.value + "\\)";
  }

  render(node) {
    this.htmlNode = document.createElement("span");
    /*    if (this.style.color) {
      this.value =
        "{\\color{" + this.style.color.toUpperCase() + "}" + this.value + "}";
      console.log("color defined", this.style.color, this.value);
    }*/
    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style);
    renderLatexIntoNode(this.value, this.htmlNode);
    node.appendChild(this.htmlNode);
  }
}

/**
 * Element LaTeX (Paragraph).
 */
export class Element_LaTeXParagraph extends ElementEleda {
  static objectsQueuedToInsertIntoLatex = [];
  /**
   * Create a Element_LaTeXParagraph.
   * @constructor
   */
  constructor(value = null) {
    super(value);
    if (this.value) {
      //first flat array parameter in case it contains subarray.
      this.value = this.value.flat();
      this.value = this.value.map((item) => convertObjectIntoLatex(item));
    }
    console.log("Paraph Latex concat this.value:", this.value, "object");
    //appendDEBUG('Element_Numeric constructor : value =' + value);
  }
  /**
   * Parse the list of inputs.
   * For each one test : 1. If toTex() method exists, 2/ it's a Question or EledaObject that know to render in HTML, 3. anything else (convert into string)
   * @param {*} node
   */
  render(node) {
    console.log("Element_LaTeXParagraph render");
    this.htmlNode = document.createElement("span");

    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style);

    var latexString = "";
    for (let object of this.value) {
      if (object instanceof Question || object instanceof ElementEleda) {
        Element_LaTeXParagraph.objectsQueuedToInsertIntoLatex.push(object);
        latexString = latexString.concat(
          " \\cssId{" + object.uuid + "}{" + "}"
        );
      } else {
        latexString = latexString.concat(object);
      }
    }
    renderLatexIntoNode(latexString, this.htmlNode);
    node.appendChild(this.htmlNode);
    Element_LaTeXParagraph.postRender();
  }
  /**
   * Static render Open Question Inline into Latex expression
   */
  static postRender() {
    if (window._MathJaxIsReady) {
      window.MathJax.typesetPromise().then(() => {
        for (let object of Element_LaTeXParagraph.objectsQueuedToInsertIntoLatex) {
          renderIntoNode(
            object,
            document.querySelector("[id='" + object.uuid + "']")
          );
        }
        //then purge Array of qu
        Element_LaTeXParagraph.objectsQueuedToInsertIntoLatex = [];
      });
    }
  }
}

/*********************OBSOLETE ***********************************/
/*********************OBSOLETE ***********************************/
/*********************OBSOLETE ***********************************/

export class Element_GridMatrix extends ElementEleda {
  /**
   * Create a Element_TableMatrix.
   * @constructor
   */

  constructor(value = null) {
    super(value);
  }

  /**
   * Set the value.
   * @param {number} numeric value
   */
  setValue(value) {
    this.value = Array.from(value);
  }

  render(node) {
    this.htmlNode = document.createElement("div");
    this.htmlNode.classList.add("columns", "is-multiline");
    //Alignment : has-text-* has no effect because is-narrow fit the cell to content
    //Color : this style gives color to text into in all columns
    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style);
    //    this.htmlNode.style.width = "-webkit-fill-available";
    for (let i in this.value) {
      renderIntoNode(this.value[i], this.htmlNode);
    }
    node.appendChild(this.htmlNode);
    //super.render(node);
  }
}

export class Element_Array extends ElementEleda {
  /**
   * Create a Element_Array.
   * @constructor
   */

  constructor(value = null) {
    super(value);
    //appendDEBUG('Element_Numeric constructor : value =' + value);
  }

  /**
   * Set the value.
   * @param {number} numeric value
   */
  setValue(value) {
    this.value = Array.from(value);
    //appendDEBUG('Element_Numeric setValue : value =' + this.value);
  }
}

/**
 * Class representing a Numeric.
 * @extends Element
 */
export class Element_Numeric extends ElementEleda {
  /**
   * Create a Element_Numeric.
   * @constructor
   */

  constructor(value = null) {
    super(Number(value));
    //appendDEBUG('Element_Numeric constructor : value =' + value);
  }

  [Symbol.toPrimitive](/*hint*/) {
    // appendDEBUG("Element_Numeric : Symbol.toPrimitive : hint=" + hint);
    // appendDEBUG("Element_Numeric : Symbol.toPrimitive : value = " + this.value);
    return Number(this.value);
  }
  /**
   * Set the value.
   * @param {number} numeric value
   */
  setValue(value) {
    this.value = Number(value);
    //appendDEBUG('Element_Numeric setValue : value =' + this.value);
  }
}

export class Element_TableMatrix extends ElementEleda {
  /**
   * Create a Element_TableMatrix.
   * @constructor
   */

  constructor(value = null) {
    super(value);
  }

  /**
   * Set the value.
   * @param {number} numeric value
   */
  setValue(value) {
    this.value = Array.from(value);
  }

  render(node) {
    this.htmlNode = document.createElement("table");
    this.htmlNode.classList.add("table", "table-eleda");
    //Color : this style gives color to text into all cells
    //Alignment : has-text-* has no effect on table => alignment is not taken into account at this level

    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToDiv(this.htmlNode, this.style); //If align is set on a table other div overlap it

    for (let i in this.value) {
      renderIntoNode(this.value[i], this.htmlNode);
    }
    node.appendChild(this.htmlNode);
  }
}

export class Element_TableColumn extends ElementEleda {
  /**
   * Create a Element_RichText.
   * @constructor
   */

  constructor(value = null) {
    super(value);
  }

  /**
   * Set the value.
   * @param {number} numeric value
   */
  setValue(value) {
    this.value = Array.from(value);
  }

  render(node) {
    this.htmlNode = document.createElement("tr");
    //Alignment : has-text-* gives alignment of all lines' cells
    applyColorAndSizeStyleToNode(this.htmlNode, this.style);
    applyAlignmentStyleToText(this.htmlNode, this.style);
    //////////////////////
    //Alignment : has-text-* gives alignment of all lines' cells
    //////////////////////////
    for (let i in this.value) {
      let spanNode = document.createElement("td");

      // applyColorAndSizeStyleToNode(spanNode, this.value[i].style);
      // applyAlignmentStyleToDiv(spanNode, this.value[i].style);
      console.log("element table :", this.value[i]);
      renderIntoNode(this.value[i], spanNode);
      this.htmlNode.appendChild(spanNode);
    }
    node.appendChild(this.htmlNode);
    //super.render(node);
  }
}
